import script from "./FormSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormSelect.vue?vue&type=script&setup=true&lang=ts"

import "./FormSelect.vue?vue&type=style&index=0&id=bd52f64a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd52f64a"]])

export default __exports__